import $ from 'domtastic'
import Scrollbar from 'smooth-scrollbar'




/* SCROLLBAR
----------------------------------------------------------------------------------------------------*/

export default class Menu {

    constructor($el) {
        this.$els = {
            ctn : $el,
        }


        this.initScrollbar()
    }


    initScrollbar() {
        this.SB = Scrollbar.init(this.$els.ctn[0], {
            continuousScrolling: false,
        })

        setTimeout(() => {
            this.onScroll(this.SB.limit)
        }, 16)

        this.SB.addListener(({ limit }) => { this.onScroll(limit) })
    }




    /* Handlers
    --------------------------------------------------------- */

    onScroll({ y: limitY }) {
        this.$els.ctn.toggleClass('has-visible-scrollbar', limitY > 0)
    }




    /* Actions
    --------------------------------------------------------- */




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



